





import { sanitizeFilename } from "../sanitizeFilename";

function richParagraphToText(paragraph) {
  return paragraph.map((segment) => segment.text).join("");
}

function titledBulletToText(bullet) {
  if (!bullet.title) {
    return bullet.body;
  }
  if (!bullet.body) {
    return bullet.title;
  }
  return `${bullet.title} ${bullet.body}`;
}

export function sectionBuilderToPptDocument(result) {
  const slides = [
  {
    kind: "title",
    title: result.title,
    subtitle: result.curriculumLabel
  }];


  if (result.introduction.length > 0) {
    slides.push({
      kind: "bullets",
      title: "Introduction",
      bullets: result.introduction.map(richParagraphToText)
    });
  }

  const conceptBullets = [];
  if (result.conceptExplanation.intro.length > 0) {
    conceptBullets.push(...result.conceptExplanation.intro.map(richParagraphToText));
  }
  if (result.conceptExplanation.bullets.length > 0) {
    conceptBullets.push(...result.conceptExplanation.bullets.map(titledBulletToText));
  }
  if (conceptBullets.length > 0) {
    slides.push({
      kind: "bullets",
      title: "Concept Explanation",
      bullets: conceptBullets
    });
  }

  if (result.teachingFlow.length > 0) {
    slides.push({
      kind: "bullets",
      title: "Teaching Flow",
      bullets: result.teachingFlow.map(titledBulletToText)
    });
  }

  if (result.realWorldExamples.length > 0) {
    slides.push({
      kind: "bullets",
      title: "Real-World Examples",
      bullets: result.realWorldExamples.map(titledBulletToText)
    });
  }

  if (result.commonMisconceptions.length > 0) {
    slides.push({
      kind: "bullets",
      title: "Common Misconceptions",
      bullets: result.commonMisconceptions.map(titledBulletToText)
    });
  }

  if (result.quickCheckQuestions.length > 0) {
    slides.push({
      kind: "bullets",
      title: "Quick Check Questions",
      bullets: result.quickCheckQuestions.map(richParagraphToText)
    });
  }

  return {
    filename: sanitizeFilename(`${result.topicLabel} section`, "section-builder"),
    title: result.title,
    subject: result.curriculumLabel,
    author: "Tema Section Builder",
    slides
  };
}